import * as React from 'react'
import { FC, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { PendingLeads } from './Sections/PendingLeads'
import { getData } from '@user/store/dashboard/widgets/gainMoreCustomers/api'
import { LeadsToQualify } from './Sections/LeadsToQualify'
import { OpenOpportunities } from './Sections/OpenOpportunities'
import { selectGainMoreCustomers } from '@user/store/dashboard/widgets/gainMoreCustomers/slice'
import { mapDashboardDataToFilters } from '@user/store/dashboard/mapper'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useCheckPermissions } from '@user/store/authorization/permissions'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

export const ContentFront: FC = () => {
  const dispatch = useAppDispatch()
  const { data } = useSelector(selectGainMoreCustomers)

  const [assignee, assignees, salesTeam, salesTeams, branches] = useMemo(
    () => mapDashboardDataToFilters(data),
    [data],
  )

  const [canViewLeads, canViewOpps] = useCheckPermissions(
    'leads_view',
    'opportunities_view',
  )

  useEffect(() => {
    dispatch(getData())
  }, [dispatch])

  return (
    <>
      <PendingLeads
        count={data.capturedLeads}
        canViewLeads={canViewLeads}
        branches={branches}
      />

      <Box my={1}>
        <Divider />
      </Box>

      <OpenOpportunities
        count={data.openOpportunities}
        value={data.openOpportunitiesValue}
        salesTeam={salesTeam}
        assignee={assignee}
        assignees={assignees}
        salesTeams={salesTeams}
        canViewOpps={canViewOpps}
      />

      <Box my={1}>
        <Divider />
      </Box>

      <LeadsToQualify
        count={data.openLeads}
        value={data.openLeadsValue}
        salesTeam={salesTeam}
        assignee={assignee}
        assignees={assignees}
        salesTeams={salesTeams}
        canViewLeads={canViewLeads}
      />
    </>
  )
}

ContentFront.displayName = 'GainMoreCustomersContentFront'
